export enum ContactFilterStatus {
    Active = 'active',
    IsRegisterOnPortal = 'isRegisterOnPortal',
    ShowAll = 'showAll'
}
